module.exports = __webpack_public_path__ + "static/imagen_06-54b9402bb392c1ad90b05fea3f156549.jpg";